<div [hidden]="!showLoader" class="loader-outer">
  <div id='loader'>
    <!--<div class='diamond'></div>
    <div class='diamond'></div>
    <div class='diamond'></div>-->
    <!--Circle loader-->
    <div class="circle-loader"></div>
    <img src="assets/img/logos/logo.png" class="logo" />
  </div>
</div>
<div id="fullPage">
  <app-header></app-header>

  <router-outlet (activate)="onRouteChange();" (onMessageClick)="onMessageClick()"></router-outlet>

  <app-footer></app-footer>
</div>
